import React, { ReactNode } from 'react';
import styled from 'styled-components/macro';
import { StylableProps } from '../../../lib/styledComponents';

import { base } from '@sdxcorp/sdx-dds-gui-lib';

const {
  atoms: {
    Icons: { HoverLogo },
  },
} = base;

interface StyledLinkProps extends StylableProps {
  children?: ReactNode;
  href?: string;
  target?: string;
  rel?: string;
}

const StyledLink = styled.a<StyledLinkProps>`
  svg {
    margin-left: 0;
  }
`;

interface SDXLogoProps extends StylableProps {
  url: string;
  openInNewPage: boolean;
}

const SDXLogo: React.FC<SDXLogoProps> = props => {
  const { openInNewPage, url } = props;
  const target = openInNewPage === true ? '_blank' : '_self';
  return (
    <StyledLink href={url} target={target} rel="noopener noreferrer" className={props.className} style={props.style}>
      <HoverLogo />
    </StyledLink>
  );
};

export default React.memo(SDXLogo);
